import { createContext, useContext } from "solid-js";
import type { _Meta } from "../meta";

export const MetaContext = createContext<_Meta.ContextActions>();

export const hooks = {
  useMeta: () => useContext(MetaContext),
};
